<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleNextStep = async () => {
  await handleNext('tutorial_spy_assign_task')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/spy.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.spy.assignTask.putToWork') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.assignTask.variousMissions') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.assignTask.defaultMission') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.assignTask.suggestTrain') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.spy.assignTask.clickAssign') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.spy.assignTask.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>